module.exports = "/_next/static/images/bf8c239ec5dec6b9bfef48d044b7add1-value_proposal_xs.png";